// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import Auth from './js/auth.js'
import axios from 'axios'
import VueProgressBar from 'vue-progressbar'
import VeeValidate, {ValidationObserver, ValidationProvider} from 'vee-validate'
import VueInstant from 'vue-instant'
import store from './store/index'
import 'vue-instant/dist/vue-instant.css'
import JwPagination from 'jw-vue-pagination'
import VueNumeric from 'vue-numeric'
import {ModelListSelect} from 'vue-search-select'
import Loading from 'vue-loading-overlay'
// import Tawk from 'vue-tawk'

require('./store/subcriber')
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('jw-pagination', JwPagination)
Vue.component('model-list-select', ModelListSelect)
Vue.component('Loading', Loading)
Vue.use(VueNumeric)
Vue.use(VueInstant)
Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.use(Auth)
Vue.use(VeeValidate)
// Vue.use(Tawk, {
//   tawkSrc: 'https://embed.tawk.to/6215660a1ffac05b1d7b3624/1fshpd6q8'
// })
Vue.use(VueProgressBar, {
  color: 'rgb(43, 140, 255)',
  failedColor: 'red',
  height: '2px'
})

// development kantor
// Vue.http.options.base = 'http://192.168.16.10/backper/public'
// Vue.http.options.root = 'http://192.168.16.10/backper/public/api'
// axios.defaults.baseURL = 'http://192.168.16.10/backper/public/api'

// Development
// Vue.http.options.base = 'http://localhost/backper/public'
// Vue.http.options.root = 'http://localhost/backper/public/api'
// axios.defaults.baseURL = 'http://localhost/backper/public/api'

// PRODUCTION
// Vue.http.options.base = 'http://perijinanbcbatam.beacukai.go.id/backper/public'
// Vue.http.options.root = 'http://perijinanbcbatam.beacukai.go.id/backper/public/api'
// axios.defaults.baseURL = 'http://perijinanbcbatam.beacukai.go.id/backper/public/api'
// PRODUCTION
Vue.http.options.base = 'https://bcbatam.com/backper/public'
Vue.http.options.root = 'https://bcbatam.com/backper/public/api'
axios.defaults.baseURL = 'https://bcbatam.com/backper/public/api'

router.beforeEach((to, from, next) => {
  // let tes = store.state.auth.token
  // store.dispatch('auth/attempt', localStorage.getItem('token'))
  // let tes = store.state.auth.token
  let isAuth = store.getters['auth/authenticated']
  // console.log('ini pas reload kan?')
  // console.log(isAuth)
  // setTimeout(() => { let isAuth =store.getters.['auth/authenticated'] }, 2000);
  if (to.matched.some((record) => record.meta.forAuth)) {
    if (isAuth) {
      let jenisAkun = store.getters['auth/user']['ppjk']
      if (to.meta.access) {
        if (to.meta.access.some((akses) => akses === jenisAkun)) {
          next()
        } else {
          next({
            path: '/unauthorize'
          })
        }
      } else {
        next()
      }
    } else {
      next({
        path: '/login',
        params: {nextUrl: to.fullPath}
      })
      // console.log('gak ada tokennya')
    }
  } else if (to.matched.some((record) => record.meta.forVisitors)) {
    if (isAuth) {
      next({
        path: '/dashboard'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
store.dispatch('auth/attempt', localStorage.getItem('token')).then(() => {
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
      App
    }
  })
})



// WEBPACK FOOTER //
// ./src/main.js